<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Feriados</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('parambanco.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/feriado"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="feriado_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="dt_feriado" slot-scope="props">
                      {{ props.rowData.dia }}/{{ props.rowData.mes }}
                    </template>
                    <template slot="uf" slot-scope="props">
                      <span v-if="props.rowData.rel_feriado_uf != null">{{
                        props.rowData.rel_feriado_uf.uf.nome
                      }}</span>
                      <span
                        v-if="
                          props.rowData.rel_feriado_uf == null &&
                          props.rowData.rel_feriado_municipio != null
                        "
                        >{{
                          props.rowData.rel_feriado_municipio.municipio.uf.nome
                        }}</span
                      >
                    </template>
                    <template slot="municipio" slot-scope="props">
                      <span
                        v-if="props.rowData.rel_feriado_municipio != null"
                        >{{
                          props.rowData.rel_feriado_municipio.municipio.nome
                        }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <span>
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FeriadoForm ref="feriadoform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import FeriadoForm from "./FeriadosForm.vue";
import FeriadoFilterBar from "./FeriadosFilterBar.vue";
// import ParamFilterBar from './ParamFilterBar'
// import ParamForm from './ParamForm'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    FeriadoForm,
    "vuetable-filterbar": FeriadoFilterBar
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      optionsMunicipio: [],
      optionsStatus: [],
      optionsUf: [],
      optionsTpFeriado: [],
      optionsFeriadoAnual: [],
      form: new Form({ cd: "", descr: "", parban_id: "", status: [] }),
      helpForm: new Form({
        recordCollection: [],
        status: "",
        statusRecord: []
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd"
        },
        {
          name: "ano",
          title: "Ano",
          sortField: "ano"
        },
        {
          name: "__slot:dt_feriado",
          title: "Data do Feriado",
          sortField: "dt_feriado"
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr"
        },
        {
          name: "feriado_anual.descr",
          title: "Indicador Recorrente",
          sortField: "feriado_anual"
        },
        {
          name: "tp_feriado.descr",
          title: "Tipo do Feriado",
          sortField: "tp_feriado"
        },
        {
          name: "__slot:uf",
          title: "Uf",
          sortField: "uf"
        },
        {
          name: "__slot:municipio",
          title: "Municipio",
          sortField: "municipio"
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status"
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        diaMes: data_filter.diaMes,
        ano: data_filter.ano,
        descr: data_filter.descr,
        tp_feriado: data_filter.tp_feriado.value,
        status: data_filter.status.value
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
      this.dataExport.forEach(obj => {
        if (obj.dia <= 9) {
          obj.dia = 0 + "" + obj.dia;
        }
        if (obj.mes <= 9) {
          obj.mes = 0 + "" + obj.mes;
        }
      });
    },
    onCreate() {
      this.$refs.feriadoform.onCreate();
    },
    onEdit(data) {
      this.$refs.feriadoform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.feriado_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.feriadoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },

    getLivGeral() {
      this.helpForm
        .get("/api/feriado/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.municipio.forEach(obj => {
            this.optionsMunicipio.push({
              label: obj.nome + " - " + obj.uf.cd,
              value: obj.municipio_id
            });
          });
          response.status.forEach(obj => {
            this.optionsStatus.push({
              label: obj.descr,
              value: obj.valor,
              text: obj.descr
            });
          });
          response.uf.forEach(obj => {
            this.optionsUf.push({
              label: obj.nome,
              value: obj.uf_id
            });
          });
          response.tp_feriado.forEach(obj => {
            this.optionsTpFeriado.push({
              label: obj.descr,
              value: obj.valor
            });
          });
          response.feriado_anual.forEach(obj => {
            this.optionsFeriadoAnual.push({
              text: obj.descr,
              value: obj.valor
            });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      }
    }
  }
};
</script>
